<p-panel>
    <div class="container-fluid gap-5">
        <div class="row">
            <div class="col">
                @if (reactiveForm) {
                    <app-reactive-form-builder
                        #builderRef
                        (stableValueChanges)="stableValueChanges($event)"
                        (goBack)="goBack()"
                        [form]="reactiveForm.formFields"
                        [id]="reactiveFormRecordId"
                        [request]="request"
                        [getRequest]="formGetRequest">
                    </app-reactive-form-builder>
                }
            </div>
        </div>
    </div>
</p-panel>
